module.exports = __webpack_public_path__ + "static/media/s8.759ace99.jpg";